import { handleActions, combineActions } from 'redux-actions'
import { fromJS, isImmutable } from 'immutable'

import * as AppActions from 'actions/app'
import * as Actions from 'actions/journalists'

export const initialState = fromJS({
  distributionLists: {
    items: [],
    total: 0
  },
  journalists: {
    items: [],
    ids: [],
    total: 0
  },
  myContacts: {
    items: [],
    ids: [],
    total: 0
  },
  jobTitles: [],
  publications: [],
  articles: [],
  news: {
    items: [],
    total: 0
  }
})

const update = (state, keys, contacts) => state.updateIn(keys, items => items.map(item => {
  const updated = contacts.find(contact => contact.get('id') === item.get('id'))

  if (updated) {
    return item.merge(updated)
  }

  return item
}))

export default handleActions({
  [Actions.searchDistributionListsSuccess]: (state, { payload }) => state
    .setIn(['distributionLists', 'items'], fromJS(payload.distributionLists))
    .setIn(['distributionLists', 'total'], payload.total),

  [Actions.searchJournalistsSuccess]: (state, { payload }) => {
    let newState = state

    if (payload.allContacts) {
      newState = newState.setIn(['journalists', 'items'], fromJS(payload.allContacts))
        .setIn(['journalists', 'items'], fromJS(payload.allContacts.contacts))
        .setIn(['journalists', 'total'], payload.allContacts.total)
        .setIn(['journalists', 'ids'], fromJS([]))
    }

    if (payload.myContacts) {
      newState = newState
        .setIn(['myContacts', 'items'], fromJS(payload.myContacts.contacts))
        .setIn(['myContacts', 'total'], payload.myContacts.total)
        .setIn(['myContacts', 'ids'], fromJS([]))
    }

    return newState
  },
  [combineActions(
    Actions.importJournalistsSuccess,
    Actions.importJournalistsToListSuccess
  )]: (state, { payload }) => {
    const contacts = fromJS(payload.contacts)

    return update(state, ['journalists', 'items'], contacts)
      .mergeIn(['myContacts', 'items'], contacts)
      .setIn(['myContacts', 'total'], state.getIn(['myContacts', 'total']) + contacts.size)
  },
  [Actions.loadJournalistNewsSuccess]: (state, { payload }) => state
    .setIn(['news', 'items'], fromJS(payload.results))
    .setIn(['news', 'total'], payload.total),

  [Actions.fetchPublicationsSuccess]: (state, { payload }) => (
    state.set('publications', fromJS(payload))
  ),
  [Actions.searchJobTitlesSuccess]: (state, { payload }) => (
    state.set('jobTitles', fromJS(payload))
  ),
  [Actions.setFilter]: (state, { payload }) => {
    const { key, value } = payload
    const immutableValue = isImmutable(value) ? value : fromJS(value)

    if ((key === 'channels' || key === 'mediaTypes') && !immutableValue.isEmpty()) {
      return state.set('publications', fromJS([]))
    }

    return state
  },

  [AppActions.resetState]: () => initialState
}, initialState)
